import { forwardRef, type HTMLAttributes } from 'react';
import styles from './Separator.module.css';

export type SeparatorProps = {
  transparent?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl';
} & HTMLAttributes<HTMLHRElement>;

export const Separator = forwardRef<HTMLHRElement, SeparatorProps>(
  ({ transparent = false, size = 'lg', className, ...rest }, ref) => (
    <hr
      ref={ref}
      className={className ? `${styles.root} ${className}` : styles.root}
      data-size={size}
      data-transparent={transparent ? 'true' : undefined}
      {...rest}
    />
  ),
);

Separator.displayName = 'Separator';
